/**
 * @description: base64 to blob
 */
export function dataURLtoBlob(base64Buf: string): Blob {
  const arr = base64Buf.split(',');
  const typeItem = arr[0];
  const mime = typeItem.match(/:(.*?);/)![1];
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

/**
 * img url to base64
 * @param url
 */
export function urlToBase64(url: string, mineType?: string): Promise<string> {
  return new Promise((resolve, reject) => {
    try {
      let canvas = document.createElement('CANVAS') as Nullable<HTMLCanvasElement>;
      const ctx = canvas!.getContext('2d');

      const img = new Image();
      img.crossOrigin = '';
      img.onload = function () {
        if (!canvas || !ctx) {
          return reject();
        }
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL(mineType || 'image/png');
        canvas = null;
        resolve(dataURL);
      };

      img.onerror = function (e) {
        reject(e);
      };
      img.src = url;
    } catch (e) {
      reject(e);
    }
  });
}

export async function getSVGContent(url): Promise<string> {
  return new Promise((r, reject) => {
    fetch(url)
      .then((response) => response.text())
      .then((svgContent) => {
        r(svgContent);
      })
      .catch((error) => reject(error));
  });
}

export async function svgToPng(options: { url: string; scale: number }): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const { url, scale } = options;
    const img = new Image();
    const canvas = document.createElement('canvas');
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      const width = img.width * scale;
      const height = img.height * scale;

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(img, 0, 0, width, height);

      // 导出 PNG
      canvas.toBlob(function (blob: Blob) {
        resolve(blob);
      }, 'image/png');
    };

    img.onerror = function (e) {
      reject(e);
    };
    img.src = url;
  });
}
